export default "//static.tradera.net/touchweb/static/output/images/appstore.ebc98d68.svg";